module.exports = __webpack_public_path__ + "static/media/MARUTI.5646abfd.txt";